import { IntercomFooter, IntercomFooterProps } from "./intercom-footer";

export type FooterProps = IntercomFooterProps;

export const Footer = (props: FooterProps) => {
  return <IntercomFooter {...props} />;
};
